<template>
  <section class="story02">
    <div class="container">
      <div class="row">
        <div class="col-sm-6 story02--li01"><img src="@/assets/images/brandstory/img02@2x.jpg" class="story02--img" alt=""></div>
        <div class="col-sm-6 story02--conwrap01">
          <div class="story02--subtit">Philosophy</div>
          <div class="story02--personal01">
            <h2 class="story02--tit01 mb-2">건강한 삶에 대한 철학</h2>
          </div>
          <p class="story02--txt">건강한 삶에 대한 고민 끝에 그 해답을
            자연의 순수하고 강한 에너지에서 찾았습니다. <br>
            흙을 뚫고 뿌리를 내려 생장을 이루는 강인한 생명력처럼
            자연의 경이로운 힘을 오롯이 담아내는 것,
            건강하고 아름다운 삶에 관한 보타랩의 철학입니다. </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 order-sm-1 order-2 story02--conwrap02">
          <div class="story02--subtit">Origin</div>
          <div class="story02--personal02">
            <h2 class="story02--tit02 mb-2">보타랩, 가장 완벽한 시작</h2>
          </div>
          <p class="story02--txt">수년간의 실험과 연구 끝에 탄생한 보타랩은<span class="brs"></span>
            원료가 가진 가장 완벽한 포뮬러를 지니고 있습니다. <br>
            독보적인 공법과 성분 개발로 놀라운 시너지를 발휘합니다. </p>
        </div>
        <div class="col-sm-6 order-sm-2 order-1 story02--li02">
          <img src="@/assets/images/brandstory/img03@2x.jpg" class="story02--img" alt="">
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 story02--li03"><img src="@/assets/images/brandstory/img04@2x.jpg" class="story02--img" alt=""></div>
        <div class="col-sm-6 story02--conwrap03">
          <div class="story02--subtit">Our Promise</div>
          <div class="story02--personal03">
            <h2 class="story02--tit03 mb-2">특별한 퍼스널케어에 대한 약속</h2>
          </div>
          <p class="story02--txt">지금까지 경험하지 못했던 퍼스널케어를 선보이기 위해<span class="brs"></span>
            보타랩은 특별한 원칙을 추구합니다. <br>
            많은 것을 담기 보다는 꼭 필요한 성분만을<span class="brs"></span>
            효율적으로 배합하여 최적의 솔루션을 제시합니다. </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Section2',
};
</script>
